import * as React from "react";
import { cn } from "../../lib/utils";

export const Card = React.forwardRef(function Card({ className, ...props }, ref) {
  return (
    <div
      ref={ref}
      className={cn(
        "rounded-[var(--radius)] bg-[hsl(var(--card))] border border-[hsl(var(--border))] shadow-[0_2px_24px_-12px_rgba(0,0,0,0.5)]",
        className
      )}
      {...props}
    />
  );
});

export function CardHeader({ className, ...props }) {
  return <div className={cn("p-4 sm:p-5 pb-3", className)} {...props} />;
}
export function CardTitle({ className, ...props }) {
  return (
    <h3
      className={cn(
        "text-sm font-semibold tracking-wide text-[hsl(var(--fg))]",
        className
      )}
      {...props}
    />
  );
}
export function CardDescription({ className, ...props }) {
  return (
    <p
      className={cn("text-xs text-[hsl(var(--muted))] mt-1", className)}
      {...props}
    />
  );
}
export function CardContent({ className, ...props }) {
  return <div className={cn("p-4 sm:p-5 pt-0", className)} {...props} />;
}
